export const eventsSelector = devices =>
  devices.reduce((a, c) => [...a, ...(c.events || [])], []);

export const locationsSelector = devices =>
  devices.reduce((a, c) => [...a, ...(c.locations || [])], []);
